module.exports = __webpack_public_path__ + "static/media/sell-used-car-easily.d5cf3c37.png";